import {
  CART_FLYOUT_CLOSE,
  CART_FLYOUT_OPEN,
  CART_FLYOUT_TOGGLE,
} from '~/redux/actions/types'

export const closeCartFlyout = () => {
  return {
    type: CART_FLYOUT_CLOSE,
  }
}

export const openCartFlyout = () => {
  return {
    type: CART_FLYOUT_OPEN,
  }
}

export const toggleCartFlyout = () => {
  return {
    type: CART_FLYOUT_TOGGLE,
  }
}
